import React from "react"
import SmiWidget from "../SmiWidget"

export function AfterContent({isDesktop}) {
    return (
        <SmiWidget blockId={(isDesktop ? '30222' : '30224')}/>
    )
}
